<template>
  <div>
    <client-only>
      <LayoutHeaderFullWidth />
    </client-only>

    <main>
      <AboutHeroSection />
      <AboutGoalSection />
      <AboutLeaderSection />
      <!--
      <div class="about-experts-wrap">
        <ExpertsSection />
      </div>
      -->
      <!-- <CertificateSection /> -->
      <!-- <EventsSection /> -->
      <!-- <PartnersSection /> -->
    </main>

    <client-only>
      <LayoutFooter />
      <LayoutBackToTop />
    </client-only>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
main {
  margin: 0 auto;
  overflow-x: hidden;
  width: 100%;
}

.about-experts-wrap :deep(.experts) {
  background-color: #fff;
}
</style>
